<template>
  <div class="nav-filter">
    <div class="nav-items">
      <a href="#" class="nav-item active" @click.prevent="handleSubjectClick({ category_id: 0 })">全部</a>
      <el-popover
        v-for="(item, index) in navItems"
        :key="index"
        placement="bottom-start"
        trigger="hover"
        width="600px"
        popper-class="nav-popover"
      >
        <template #default>
          <div class="subject-list">
            <p
              v-for="(subject, sIndex) in item.categories"
              :key="sIndex"
              class="subject-item"
              @click="handleSubjectClick(subject)"
            >{{subject.url}}</p>
          </div>
        </template>
        <template #reference>
          <a href="#" class="nav-item">{{item.group_name}}</a>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import { getEduGroup } from '@/axios/education'

export default {
  name: 'NavFilter',
  props: {
    needRedirect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      navItems: []
    }
  },
  created () {
    this.getNavData()
  },
  methods: {
    getNavData () {
      // 直接从localStorage获取educationType作为module_id
      const moduleId = localStorage.getItem('educationType')

      if (moduleId) {
        const params = {
          appid: 'wzwebapp',
          timestamp: parseInt(new Date().getTime() / 1000),
          module_id: moduleId
        }
        const signO = sign(params)
        params.sign = signO

        getEduGroup(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.navItems = res.data.data || []
          }
        }).catch(error => {
          console.error('获取教育分组数据失败:', error)
        })
      } else {
        console.warn('localStorage中未找到educationType，无法获取导航数据')
      }
    },
    handleSubjectClick (subject) {
      if (this.needRedirect) {
        this.$router.push({
          path: '/education/index',
          query: {
            category_id: subject.category_id
          }
        })
      } else {
        this.$emit('subject-click', subject)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav-filter {
  margin-bottom: 20px;

  .nav-items {
    display: flex;
    gap: 24px;

    .nav-item {
      text-decoration: none;
      color: #666666;
      font-size: 14px;
      transition: color 0.3s;
      cursor: pointer;

      &.active {
        color: #7DBD83;
        font-weight: 500;
      }

      &:hover {
        color: #7DBD83;
      }
    }
  }
}

:deep(.nav-popover) {
  padding: 16px;
  min-width: 600px;
  background: #fff;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

  .subject-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px 20px;
    padding: 0;
    margin: 0;

    .subject-item {
      text-decoration: none;
      color: #666666;
      font-size: 13px;
      transition: color 0.3s;
      display: block;
      white-space: nowrap;
      line-height: 1.5;
      cursor: pointer !important;

      &:hover {
        color: #7DBD83;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/NavFilter.vue